import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';

@Component({
	selector: 'app-recover-tp-number',
	templateUrl: './recover-tp-number.component.html',
	styleUrls: ['./recover-tp-number.component.scss']
})
export class RecoverTpNumberComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {


	constructor(
		protected modalService: ModalService,

	) {
		super(modalService);

	}

	ngOnInit() {
	}

	ngOnDestroy(): void {
	}

	closeModal() {
		this.modalService.close();
	}

}
